export default "__VITE_ASSET__71032ff8__"